import { InvoiceModel } from 'api/invoice';
import { asCurrency, CollapsableSection, Column, Columns, FormDisputeInput, FormInput, ReadOnly, TopSection } from 'lqx-react';
import * as React from 'react';
import { ComponentsSection } from '../../../../../common';
import { Tooltip } from "@material-ui/core";
import { globalStore } from 'api';

const showPromiseToPayDateStatuses = ['AwaitingRemittance', 'PaymentInTransit', 'Reconciled', 'PaymentComplete'];

function numberToLocaleWithDecimals(params, options = {}): string {
    const paramValue = params == null || params.value === undefined ? params : params.value;
    return paramValue == null ?
        "" :
        paramValue.toLocaleString("en-US", { minimumFractionDigits:2, maximumFractionDigits:2, ...options});
  }

export const InvoiceManagement = ({ invoice, original } : { invoice : InvoiceModel, original : InvoiceModel }) => {
    const showPromiseToPayDate = showPromiseToPayDateStatuses
        .includes(invoice.invoiceStatus);

    const getInternalStatus = (invoiceInternalId) => {
        const statusInfo = globalStore.getInternalInvoiceStatusInfo(invoiceInternalId);
        return (statusInfo)
            ? statusInfo.internalStatus
            : '';
    }

    const getInternalStatusDescription = (invoiceInternalId) => {
        const statusInfo = globalStore.getInternalInvoiceStatusInfo(invoiceInternalId);
        return (statusInfo)
            ? statusInfo.statusDescription
            : '';
    }

    return (
        <TopSection id="invoice-management" title="Invoice Management">
            <CollapsableSection id="invoice-details" title="Invoice Details" >
                <Columns>
                    <Column>
                        <FormInput readOnly label="Invoice #" value={invoice.invoiceNumber} />
                        <FormDisputeInput readOnly
                            label="PO #"
                            value={invoice.poNumber}
                            $value={invoice.dispute.$.poNumber}
                        />
                        <FormInput readOnly label="SO #" value={invoice.soNumber} />
                        <FormInput readOnly label="Invoice Date" date value={invoice.invoiceDateUtc} placeholder=" " />
                        <FormInput readOnly label="Invoice Sent Date" date value={invoice.invoiceSentDateUtc} placeholder=" " />
                        <FormDisputeInput readOnly
                            label="Invoice Due Date"
                            date
                            value={invoice.invoiceDueDateUtc}
                            $value={invoice.dispute.$.invoiceDueDateUtc}
                            placeholder=" "
                        />
                    <FormInput readOnly label="Invoice Currency" value={invoice.currency} />
                    </Column>
                    <Column>
                    { showPromiseToPayDate ?
                            <FormInput readOnly label="Promise to Pay" date value={invoice.promiseToPayDateUtc} />
                        :
                            null
                        }
                        <FormInput readOnly label="Invoice Amount" value={asCurrency(invoice.invoicedAmount)} />
                        <FormDisputeInput readOnly
                            label="Outstanding Amount"
                            positive number
                            value={asCurrency(invoice.outstandingInvoiceAmount)}
                            $value={invoice.dispute.$.outstandingAmount}
                        />
                        <FormInput readOnly label={`Original Invoiced Amount (${invoice.currency})`} value={numberToLocaleWithDecimals(invoice.invoicedAmountFx)} />
                        <FormInput readOnly label={`Original Outstanding Amount (${invoice.currency})`} value={numberToLocaleWithDecimals(invoice.outstandingInvoiceAmountFx)} />
                        <Tooltip title={ getInternalStatusDescription(invoice.internalStatusId) }>
                            <FormInput readOnly label={`Internal Status`} value={getInternalStatus(invoice.internalStatusId)}/>
                        </Tooltip>
                    </Column>
                </Columns>
            </CollapsableSection>

            {/* TODO: Could be a good idea to m ove this up, if the reaonly condition is the same for other invoice details */}
            <ReadOnly.Provider value={ invoice.invoiceStatus === 'PaymentComplete' }>
                <ComponentsSection parts={ invoice.parts } originalParts={original.parts}
                                disableAdd
                                disableRemove
                                allowZeroQuantity/>
            </ReadOnly.Provider>
        </TopSection>
    );
};
